// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R2W8","rootMobile":"styles_rootMobile__1XRLp"};